/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/core';

import { minTablet, minDesktop, mediaPhone } from '../styles/breakpoints';
import { PrimaryColor, TextColor } from '../styles/colors';

import ExternalSourceShape from './ExternalSourceShape';
import ExternalSource from './ExternalSource';
import Collapsor from './Collapsor';

import { SectionHeadlineFontStyles, SectionIdFontStyles } from './styles';

const Container = styled.li`
  list-style-type: none;
  min-height: ${({ showId }) => (showId ? '68px' : '55px')};

  ${mediaPhone} {
    padding-left: 25px;
    padding-right: 25px;
  }
  ${minTablet} {
    padding-left: 20px;
  }
`;

const HeaderWithCollapsedSection = css`
  padding-bottom: 25px;

  ${minDesktop} {
    padding-bottom: 35px;
  }
`;

const Header = styled.div`
  position: relative;

  margin-top: 10px;

  ${minTablet} {
    margin-top: 20px;
  }

  ${minDesktop} {
    margin-top: 25px;
  }

  ${({ open }) => !open && HeaderWithCollapsedSection}
`;

const HeaderStart = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SectionId = styled.div`
  ${SectionIdFontStyles};

  ${mediaPhone} {
    margin-bottom: 2px;
  }
`;

const HeadlineWithIdStyles = css`
  padding-left: 80px;

  ${mediaPhone} {
    padding-left: 65px;
  }
`;

const HeadlineWithoutIdStyles = css`
  padding-left: 0;

  ${mediaPhone} {
    padding-left: 55px;
  }
`;

const Headline = styled.div`
  ${SectionHeadlineFontStyles};

  line-height: 1.3;

  padding-top: 6px;

  color: ${({ open }) => (open ? PrimaryColor : TextColor)};

  cursor: pointer;
  &:hover {
    color: ${PrimaryColor};
    @media (hover: none) {
      color: ${({ open }) => (open ? PrimaryColor : TextColor)};
    }
  }

  ${minTablet} {
    padding-top: 7px;
    padding-right: 60px;
  }

  ${({ showId }) => (showId ? HeadlineWithIdStyles : HeadlineWithoutIdStyles)}
`;

const SourcesWithIdStyles = css`
  padding: 40px 0 40px 65px;
  ${minTablet} {
    padding: 40px 20px 40px 80px;
  }
  ${minDesktop} {
    padding: 40px 40px 40px 80px;
  }
`;

const SourcesWithoutIdStyles = css`
  padding: 40px 0 40px 0;
  ${minTablet} {
    padding: 40px 20px 40px 0;
  }
  ${minDesktop} {
    padding: 40px 40px 40px 0;
  }
`;

const SourcesCollapsed = css`
  display: none;
`;

const SourcesOpened = css`
`;

const Sources = styled.ul`
  ${({ showId }) => (showId ? SourcesWithIdStyles : SourcesWithoutIdStyles)}
  ${({ open }) => (open ? SourcesOpened : SourcesCollapsed)}
`;

const BounceAnimation = keyframes`
  from {
    transform: translate3d(0,10px,0);
  }

  to {
    transform: translate3d(0,0,0);
  }
`;

const ZoomAnimation = keyframes`
  from {
    transform: scale(1);
  }

  to {
    transform: scale(1.1);
  }
`;

const BounceStyles = css`
  *:hover > & {
    animation: ${BounceAnimation} .4s alternate infinite;
    @media (hover: none) {
      animation: none;
    }
  }
`;

const ZoomStyles = css`
  *:hover > & {
    animation: ${ZoomAnimation} .4s alternate infinite;
    @media (hover: none) {
      animation: none;
    }
  }
`;

const CollapsorPhone = styled(Collapsor)`
  ${({ open }) => (open ? ZoomStyles : BounceStyles)};

  display: none;
  ${mediaPhone} {
    display: block;
  }
  margin-top: ${({ showId }) => (showId ? '0' : '10px')}; 
`;

const CollapsorRight = styled(Collapsor)`
  ${({ open }) => (open ? ZoomStyles : BounceStyles)};

  position: absolute;
  top: 10px;
  right: 25px;
  ${minDesktop} {
    right: 35px;
  }
  ${mediaPhone} {
    display: none;
  }
`;

class ExternalLinksSection extends React.Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
  }

  toggleCollapse() {
    this.setState(state => ({ isOpen: !state.isOpen }));
  }

  render() {
    const { id, headline, sources, showId, className } = this.props;
    const { isOpen } = this.state;
    return (
      <Container className={className} showId={showId}>
        <Header open={isOpen}>
          <HeaderStart>
            { showId && <SectionId>{ id }</SectionId> }
            <CollapsorPhone onClick={() => this.toggleCollapse()} showId={showId} open={isOpen} />
          </HeaderStart>
          <Headline showId={showId} open={isOpen} onClick={() => this.toggleCollapse()} dangerouslySetInnerHTML={{ __html: headline }} />
          <CollapsorRight onClick={() => this.toggleCollapse()} open={isOpen} />
        </Header>
        <Sources showId={showId} open={isOpen}>
          { sources.map(({ type, body, url, download }) => (
            <ExternalSource key={body} type={type} body={body} url={url} download={download} />
          ))}
        </Sources>
      </Container>
    );
  }
}

ExternalLinksSection.propTypes = {
  id: PropTypes.string,
  headline: PropTypes.string.isRequired,
  sources: PropTypes.arrayOf(ExternalSourceShape).isRequired,
  showId: PropTypes.bool,
  className: PropTypes.string,
};

ExternalLinksSection.defaultProps = {
  id: undefined,
  showId: false,
  className: undefined,
};

export default ExternalLinksSection;



// WEBPACK FOOTER //
// ./src/components/ExternalLinksCollection/ExternalLinksSection.js